import { render } from "./my-grid.vue?vue&type=template&id=36f417b4"
import script from "./my-grid.vue?vue&type=script&lang=js"
export * from "./my-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__